import { createContext } from 'react';
import type { FireAlarmViewModel } from '../api/adapters';

export interface FireAlarmContextValue {
  isFireAlarmActive: boolean;
  fireAlarmTriggeredAt: number | null;
  /** Latest fire alarm view model, regardless of state. */
  fireAlarm: FireAlarmViewModel;
  /** Open the emergency panel — the only place fire mode can be
   *  triggered, inspected or resolved. Lives on this context rather
   *  than on a context of its own because every caller that wants the
   *  panel (the status banner, the top bar) already needs the alarm
   *  state to decide how to label the control. */
  openFireModePanel: () => void;
}

export const FireAlarmContext = createContext<FireAlarmContextValue | null>(null);
